import React from "react";
import {Button, Flex, Space} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router-dom";
import {FilesBrowser} from "../common/FilesBrowser";
import Title from "antd/es/typography/Title";
import {useAppSelector} from "../../feature/tools";
import {editorRoles, NavigateWithUserPermission} from "../common/WithUserPermission";

export const FilesContent = () => {
    const {projectId, storyId} = useParams()
    const creator = useAppSelector(state => state.users.creator)
    const navigate = useNavigate()


    return (
        <NavigateWithUserPermission roles={editorRoles}>
            <Flex justify={'space-between'}>

                <Space>
                    <Button type={'text'}
                            onClick={() => navigate(-1)}
                            icon={<FontAwesomeIcon icon={faAngleLeft}/>}/>
                    <Title level={4} style={{margin: 0}}>File Manager</Title>
                </Space>
            </Flex>
            <div style={{height: 10}}></div>
            <FilesBrowser
                root={creator?.id + "/" + (projectId ? (projectId + "/") : "") + (storyId ? (storyId + "/") : "")}
            />
        </NavigateWithUserPermission>
    )
}